import { isNil, omitBy, isEmpty } from 'lodash';
import { transformShippingOptionDto, transformShippingOptionDtos } from './shipping-option';
import { transformCurrencyAmountDto } from './currency-amount';
export const transformDeliveryTypeHomeDto = _ref => {
  let {
    price,
    delivery_type,
    shipping_options
  } = _ref;
  return {
    price: transformCurrencyAmountDto(price),
    deliveryType: delivery_type,
    shippingOptions: shipping_options && transformShippingOptionDtos(shipping_options)
  };
};
export const transformDeliveryTypePickupDto = _ref2 => {
  let {
    price,
    delivery_type,
    package_types_ids,
    contains_different_prices,
    shipping_option
  } = _ref2;
  return {
    price: transformCurrencyAmountDto(price),
    deliveryType: delivery_type,
    packageTypeIds: package_types_ids,
    containsDifferentPrices: contains_different_prices,
    shippingOption: shipping_option && transformShippingOptionDto(shipping_option)
  };
};
export const transformDeliveryTypeCustomDto = _ref3 => {
  let {
    price,
    delivery_type
  } = _ref3;
  return {
    price: transformCurrencyAmountDto(price),
    deliveryType: delivery_type
  };
};
export const transformDeliveryTypeMeetupDto = _ref4 => {
  let {
    delivery_type
  } = _ref4;
  return {
    deliveryType: delivery_type
  };
};
export const transformDeliveryTypesDto = _ref5 => {
  let {
    home,
    pickup,
    meetup,
    custom
  } = _ref5;
  const deliveryTypes = omitBy({
    pickup: pickup && transformDeliveryTypePickupDto(pickup),
    home: home && transformDeliveryTypeHomeDto(home),
    custom: custom && transformDeliveryTypeCustomDto(custom),
    meetup: meetup && transformDeliveryTypeMeetupDto(meetup)
  }, isNil);
  return isEmpty(deliveryTypes) ? null : deliveryTypes;
};
export const transformDeliveryTypesResponse = _ref6 => {
  let {
    selected_delivery_type,
    delivery_types
  } = _ref6;
  return {
    selectedDeliveryType: selected_delivery_type,
    deliveryTypes: transformDeliveryTypesDto(delivery_types)
  };
};